import {
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Box,
  withStyles
} from '@material-ui/core';
import { Skeleton as MuiSkeleton } from '@material-ui/lab';
import { ColumnsType } from '@setvi/shared/types';
import { CSSProperties } from 'react';

const Skeleton = withStyles({
  root: {
    width: '100%',
    height: 20
  }
})(MuiSkeleton);

interface STableLoaderProps {
  columns?: ColumnsType;
  rows?: number;
}
interface CellStyle {
  width?: CSSProperties['width'];
  maxWidth?: CSSProperties['maxWidth'];
}

export const TableLoader = ({ columns, rows = 8 }: STableLoaderProps) => {
  const defaultStyles: CellStyle[] = [
    { width: '10%' },
    { width: '75%' },
    { width: '5%' }
  ];

  const styles = columns || defaultStyles;

  const getCell = (style: CellStyle) => (
    <TableCell style={style}>
      <Skeleton variant="rect" height={20} />
    </TableCell>
  );

  return (
    <Box>
      <TableContainer>
        <Table aria-label="Folders Table">
          <TableBody>
            {Array(rows)
              .fill(null)
              .map(index => (
                <TableRow key={index}>{styles.map(i => getCell(i))}</TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
